import { render } from "./slack.vue?vue&type=template&id=f9892440"
import script from "./slack.vue?vue&type=script&lang=js"
export * from "./slack.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__